import { Sort } from './sort.data';

export interface PageRequest {
  page?: number;
  size?: number;
  sort?: Sort;
  searchText?: string;
  customerId?: number;
}

export namespace PageRequest {
  export function mapToApiValue({ page, size, searchText, sort }: PageRequest): any {
    return {
      page,
      size,
      textSearch: searchText,
      sort: sort && Sort.mapToApiValue(sort),
    };
  }
  export function mapToQuery({ page, size, searchText, sort, customerId }: PageRequest): any {
    return {
      page,
      size,
      ...(searchText && { textSearch: searchText }),
      ...(sort?.sortBy && sort?.direction && { sort: Sort.mapToQueryParam(sort) }),
      ...(customerId && { customerId }),
    };
  }
}
